import { Component } from '@angular/core';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { PracticeSkill } from '../../../../models/PracticeSkill';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { Filter } from '../../../../models/GenericCRUD/Filter';

@Component({
  selector: 'app-practice-skills-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent,
  ],
  templateUrl: './practice-skills-configuration.component.html',
  styleUrl: './practice-skills-configuration.component.css'
})
export class PracticeSkillsConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Categoría', active: true, type: 'text', key: 'category_label', sort: true },
    { name: 'Licencias', active: true, type: 'array', key: 'licenses.name', sort: false },
    { name: 'Estado', active: true, type: 'reactive-boolean', key: 'active', sort: true, onLabel: 'Activo', offLabel: 'Inactivo' },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy HH:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy HH:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    {
      name: 'category',
      type: 'select',
      label: 'Categoría',
      validations: 'required',
      singleSelection: true,
      optionsList: [
        { id: 'control_vehiculo', name: 'Control del Vehículo' },
        { id: 'maniobras', name: 'Maniobras' },
        { id: 'normativa', name: 'Normativa y Circulación' },
        { id: 'seguridad', name: 'Seguridad y Observación' }
      ]
    },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    {
      name: 'licenses',
      type: 'select',
      label: 'Permisos Oficiales',
      colspan: 2,
      validations: 'required',
      singleSelection: false,
      url: '/config/license/index'
    },
    {
      name: 'active',
      type: 'boolean-switch',
      label: 'Estado',
      validations: 'required'
    },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    {
      name: 'category',
      type: 'select',
      label: 'Categoría',
      validations: 'required',
      singleSelection: true,
      optionsList: [
        { id: 'control_vehiculo', name: 'Control del Vehículo' },
        { id: 'maniobras', name: 'Maniobras' },
        { id: 'normativa', name: 'Normativa y Circulación' },
        { id: 'seguridad', name: 'Seguridad y Observación' }
      ]
    },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    {
      name: 'licenses',
      type: 'select',
      label: 'Permisos Oficiales',
      colspan: 2,
      validations: 'required',
      singleSelection: false,
      url: '/config/license/index'
    },
    {
      name: 'active',
      type: 'boolean-switch',
      label: 'Estado',
      validations: 'required'
    },
  ];

  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'habilidad de práctica',
    createButtonTitle: 'Nueva habilidad',
    cols: 2,
    createApiSlug: '/practice-skills',
    formTitle: 'Crear habilidad de práctica',
    formButtonTitle: 'Crear habilidad',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'habilidad',
        createButtonTitle: '',
        cols: 2,
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl',
        createApiSlug: '',
        originalUpdateApiSlug: '/practice-skills/{{id}}',
        updateApiSlug: '',
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar esta habilidad de práctica?',
      deleteRowOnResponse: true,
      actionSlug: '/practice-skills/{{id}}',
    }
  ]

  table: GenericTable<Paginator<PracticeSkill>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/practice-skills',
    paginate: true,
    name: 'habilidades de práctica',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|description', operator: 'like', placeholder: 'Nombre o descripción' },
    {
      type: 'select',
      key: 'category',
      operator: '=',
      placeholder: 'Categoría',
      url: '/practice-skills/categories'
    },
    {
      type: 'select',
      key: 'active',
      operator: '=',
      placeholder: 'Estado',
      url: '/practice-skills/statuses'
    },
  ];

  genericCRUD: GenericCRUD<Paginator<PracticeSkill>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}
